export default "__VITE_ASSET__DMVnWv82__"